import React from "react";
import { Repeat, Bell } from "lucide-react";
import { getNextOccurrences } from "../utils/recurrencePreview";
import { reminderLabelFromTask, isRecurringTask } from "../utils/taskReminderSync";

const RepeatPreview = ({ task }) => {
    const occurrences = getNextOccurrences(task, 5);
    const hasReminder = String(task?.reminder_type || "none") !== "none";
    if (!occurrences.length && !hasReminder) return null;

    return (
        <div className="mt-4 rounded-xl border border-line bg-surface-2 p-3">
            {hasReminder && (
                <div className="flex items-center gap-2 mb-3 pb-2 border-b border-line">
                    <Bell size={14} className="text-primary" />
                    <p className="text-xs text-ink-secondary">
                        Reminder: <span className="font-medium text-ink">{reminderLabelFromTask(task)}</span>
                    </p>
                </div>
            )}
            {isRecurringTask(task) && occurrences.length > 0 && (
                <>
                    <div className="flex items-center gap-2 mb-2">
                        <Repeat size={14} className="text-primary" />
                        <h3 className="text-xs font-semibold uppercase tracking-wide text-ink-muted">
                            Next occurrences
                        </h3>
                    </div>
                    <ul className="space-y-1">
                        {occurrences.map((occ, i) => (
                            <li
                                key={i}
                                className="text-xs text-ink-secondary py-1 border-b border-line last:border-0"
                            >
                                {occ.label}
                            </li>
                        ))}
                    </ul>
                </>
            )}
        </div>
    );
};

export default RepeatPreview;
